import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React, { useState } from 'react';
import { AbstractCourse } from '../../../../../../../api/types/settings/studies/abstract-course';
import { Button } from 'primereact/button';
import { removeAbstractCourseFromProgram } from '../operation/remove-abstract-course-from-program';

export const AbstractProgramExistingCourses: React.FC<{
  abstractProgramId: number;
  abstractCourses: AbstractCourse[];
}> = ({ abstractProgramId, abstractCourses }) => {
  const [deleteCourseId, setDeleteCourseId] = useState<number | null>(null);
  return (
    <div>
      <DataTable
        emptyMessage={
          <div style={{ textAlign: 'right' }}>
            לא נמצאו נתונים, ניתן להוסיף קורסים לתוכנית
          </div>
        }
        value={abstractCourses}
        dataKey="id"
        tableStyle={{ maxWidth: '780px', direction: 'rtl' }}
      >
        <Column
          style={{ textAlign: 'right' }}
          field="courseName"
          header="שם הקורס"
        ></Column>
        <Column
          field="courseHours"
          header="שעות"
          style={{ textAlign: 'right' }}
        ></Column>
        <Column
          field="attendancePercentage"
          header="אחוז נוכחות"
          style={{ textAlign: 'right' }}
        ></Column>
        <Column
          header="מחיקה"
          style={{ textAlign: 'right', width: '100px' }}
          body={(rowData: AbstractCourse) => (
            <Button
              icon="pi pi-trash"
              loading={deleteCourseId === rowData.id}
              className="p-button-danger p-button-text"
              onClick={() =>
                removeAbstractCourseFromProgram(
                  abstractProgramId,
                  rowData.id,
                  setDeleteCourseId,
                )
              }
            />
          )}
        />
      </DataTable>
    </div>
  );
};
